import styled from '@emotion/styled'
import { ReactNode } from 'react'

const StyledChip = styled.div<{
    textColor: string
    borderColor: string
    backgroundColor: string
}>`
    height: 2.8rem;
    padding-left: 0.8rem;
    padding-right: 0.8rem;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 0.4rem;
    font-size: 1.4rem;
    color: ${(p) => p.textColor};
    border: 0.1rem solid ${(p) => p.borderColor};
    background-color: ${(p) => p.backgroundColor};
    font-family: Inter;
    line-height: 2rem;
    letter-spacing: -0.04rem;
    font-weight: 500;
    font-style: normal;
    column-gap: 0.8rem;
`

type CommonChipProps = {
    label?: string
    textColor: string
    borderColor: string
    backgroundColor: string
    Icon?: ReactNode
}

const CommonChip = ({
    label,
    textColor,
    borderColor,
    backgroundColor,
    Icon,
}: CommonChipProps) => {
    return (
        <StyledChip
            textColor={textColor}
            borderColor={borderColor}
            backgroundColor={backgroundColor}
        >
            {Icon && Icon}
            {label}
        </StyledChip>
    )
}

export default CommonChip
